<template>
  <div class="sp-sort">
    <SortMenu
      ref="menu"
      :draft="draftValue"
      :options="options"
      :select-id="selectId"
      :trigger-label="selectedLabel"
      :trigger-prefix="menuTriggerPrefix"
      :disabled="isMenuDisabled"
      :title="dialogTitle"
      :close-text="closeText"
      :caret-image="caretImage"
      :focus-ring="toBoolean(focusRing)"
      :anchor-host="toBoolean(anchorHost)"
      :auto-height="toBoolean(autoHeight)"
      :toggle-test-id="toggleTestId"
      :option-test-id="optionTestId"
      @select="handleSelect"
      @apply="handleApply"
    />
  </div>
</template>

<script setup>
import { toBoolean } from "#ce/utils/props";
import { formAssociatedHost } from "#ce/framework/utils";
import SortMenu from "./components/SortMenu.ce.vue";
import { props as propsDefinitions } from "./props.js";
import { useSortControl } from "./composables/useSortControl";
defineOptions(formAssociatedHost());
const props = defineProps(propsDefinitions);
const { menu, draftValue, options, selectedLabel, isMenuDisabled, menuTriggerPrefix, handleSelect, handleApply } =
  useSortControl(props);
</script>

<style>
:host {
  display: inline-block;
  position: relative;
}
</style>
